import {isFeatureEnabled} from '@github-ui/feature-flags'
import {o1ModelNames} from './playground-types'

export function supportsStreaming(model: {name: string}) {
  if (model.name === 'o3-mini' && isFeatureEnabled('github_models_o3_mini_streaming')) {
    return true
  }

  if (model.name === 'o3' && isFeatureEnabled('github_models_o3_streaming')) {
    return true
  }

  return !o1ModelNames.includes(model.name)
}

export function supportsTokenCounting(model: {name: string}) {
  return !o1ModelNames.includes(model.name)
}

export function supportsStructuredOutput(model: {name: string; publisher: string}) {
  // o1 models currently don't support structured output at all
  if (o1ModelNames.includes(model.name)) {
    return false
  }

  // all models 'support' JSON output, but some of them are not trained on enough JSON
  // to be able to actually do it without spinning forever and outputting \n tokens
  const publisher = model.publisher.toLowerCase()
  if (publisher === 'openai' || publisher === 'mistral ai') {
    return true
  }

  return false
}

export function supportsJsonSchemaStructuredOutput(model: {name: string}) {
  // currently only GPT-4o supports JSON Schema Structured Output
  return model.name.toLowerCase() === 'gpt-4o'
}

export function supportsStreamingOptions(model: {publisher: string}): boolean {
  return model.publisher.toLowerCase() === 'openai'
}
